export const alloggiatiAccountMapper = (data) => {
    return {
        id: data.id,
        nickname: data.nickname,
        username: data.username,
        password: data.password,
        wskey: data.wskey,
        alloggiatiRefs: Array.isArray(data.alloggiatiRefs) ? data.alloggiatiRefs.map(r => alloggiatiRefMapper(r)) : [],
    }
}

export const alloggiatiRefMapper = (data) => {
    return {
        id: data.id,
        ref: data.ref,
        accommodationUnitIds: Array.isArray(data.accommodationUnitIds) ? data.accommodationUnitIds : [],
    }
}